import { HStack, VStack, AspectRatio, Box, Heading, Icon, Image, Text } from '@chakra-ui/react';

import { AiFillEnvironment } from 'react-icons/ai';
import { IoTimeSharp } from 'react-icons/io5';

import defaultImage from '../../assets/images/defaultImage.png';

type RestaurantCardProps = {
  name?: string;
  logo?: string;
  image?: string;
  time?: string;
  address?: string;
  onNavigate?: () => void;
};

export default function RestaurantCard({
  name = '',
  logo = '',
  image = '',
  time = '',
  address = '',
  onNavigate,
}: RestaurantCardProps) {
  const baseImgW = 160;
  const mdImgW = 180;
  return (
    <HStack
      as="a"
      align="stretch"
      py={2}
      borderBottomWidth="1px"
      borderColor="wsGray.500"
      onClick={onNavigate}
      cursor="pointer"
    >
      <VStack py={2} flex="1" align="flex-start" overflow="hidden">
        <Heading fontSize="md" maxW={{ base: '10rem', sm: '16rem', md: '12rem' }} isTruncated>
          {name}
        </Heading>

        <HStack overflow="hidden">
          <Icon as={AiFillEnvironment} boxSize="1.125rem" color="gray.500" />
          <Text
            fontSize="xs"
            color="gray.500"
            maxW={{ base: '10rem', sm: '16rem', md: '12rem' }}
            isTruncated
          >
            {address}
          </Text>
        </HStack>

        <HStack>
          <Icon as={IoTimeSharp} boxSize="1.125rem" color="gray.500" />
          <Text
            fontSize="xs"
            color={['公休', '未營業'].includes(time) ? 'red.500' : 'gray.500'}
            isTruncated
          >
            {time}
          </Text>
        </HStack>
      </VStack>
      <Box
        w={{ base: `${baseImgW}px`, md: `${mdImgW}px` }}
        h={{ base: `${(baseImgW / 5) * 3}px`, md: `${(mdImgW / 5) * 3}px` }}
        pos="relative"
      >
        <AspectRatio ratio={5 / 3}>
          <Image src={image || defaultImage} loading="lazy" borderRadius="6px" />
        </AspectRatio>
        <Image
          pos="absolute"
          top={1}
          left={2}
          src={logo || defaultImage}
          borderRadius="full"
          boxSize="2rem"
        />
      </Box>
    </HStack>
  );
}
